import { PureComponent } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { APP_NAME } from '../../../utils/constant';
import { adminAllReportData } from '../../../store/actions';
import { ReportSelector } from './reportSelector';

import '../../reports/reports.scss';

class SystemReports extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  async componentDidMount() {
    const { t } = this.props;
    document.title = `${t('admin.system_reports.title')} | ${APP_NAME}`;
    const { adminAllReportData } = this.props;
    adminAllReportData();
  }

  render() {
    return <ReportSelector {...this.props} />;
  }
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      adminAllReportData,
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(SystemReports));
